import { Components, Theme } from '@mui/material';

const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
  styleOverrides: {
    colorPrimary: ({ theme }) => ({
      '&.Mui-checked .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
      },
      '&.Mui-disabled.Mui-checked .MuiSvgIcon-root': {
        color: theme.palette.success.light,
      },
    }),
  },
  variants: [
    {
      props: {
        size: 'small',
      },
      style: ({ theme }) => ({
        padding: theme.spacing(1),
      }),
    },
  ],
};

export default MuiCheckbox;
